export const API_NAME = process.env.APP_NAME || process.env.REACT_APP_APP_NAME;
export const API_URL = process.env.API_URL || process.env.REACT_APP_API_URL;
export const API_VERSION = process.env.API_VERSION || process.env.REACT_APP_API_VERSION;

export const API_CLIENT_ID = process.env.API_CLIENT_ID || process.env.REACT_APP_API_CLIENT_ID;
export const API_CLIENT_SECRET = process.env.API_CLIENT_SECRET || process.env.REACT_APP_API_CLIENT_SECRET;

export const PUSHER_APP_KEY = process.env.PUSHER_APP_KEY || process.env.REACT_APP_PUSHER_APP_KEY;
export const PUSHER_APP_CLUSTER = process.env.PUSHER_APP_CLUSTER || process.env.REACT_APP_PUSHER_APP_CLUSTER;
export const RELEASE_VERSION = process.env.RELEASE_VERSION || process.env.REACT_APP_RELEASE_VERSION;